// removed by extract-text-webpack-plugin
module.exports = {"root":"AccordionItem__root___fB4z8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItem/AccordionItem.scss
// module id = 1002
// module chunks = 0